import { ComponentGif } from '../component.constants';
import { ImageViewFit } from '../image/image-static-preview';
import { ImageContainer } from '../image/image.style';
import { computePaddingTop } from '../shared/component-height/component-dimension.utils';
import {
  ComponentHeightWrapper,
  ComponentInnerWrapper,
} from '../shared/component-height/component-dimensions.style';

const GifStaticPreview = ({
  properties: { printImageUrls, dimensionData },
}: Omit<ComponentGif, '__typename'>) => {
  return (
    <ComponentHeightWrapper
      style={{
        paddingTop: `${computePaddingTop(dimensionData)}%`,
      }}
    >
      <ComponentInnerWrapper>
        <ImageContainer $fullBorderRadius>
          <ImageViewFit imageUrls={printImageUrls || []} />
        </ImageContainer>
      </ComponentInnerWrapper>
    </ComponentHeightWrapper>
  );
};

export default GifStaticPreview;
